var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group mt-2" }, [
    _c(
      "label",
      { staticClass: "form-label", attrs: { for: "uniq_id_" + _vm.f_uniq } },
      [_vm._v("\n\t\t\t" + _vm._s(_vm.f_title) + "\n\t\t")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input-group flex-nowrap" },
      [
        _c("div", { staticClass: "input-group-prepend" }, [
          _c("span", { staticClass: "input-group-text" }, [
            _c("i", { staticClass: "fal fs-xl", class: _vm.f_icon }),
          ]),
        ]),
        _vm._v(" "),
        !_vm.is_phone
          ? _c("b-form-input", {
              staticClass: "form-control",
              attrs: { id: "uniq_id_" + _vm.f_uniq, disabled: _vm.is_disabled },
              on: { change: _vm.updateValue },
              model: {
                value: _vm.drw_field,
                callback: function ($$v) {
                  _vm.drw_field = $$v
                },
                expression: "drw_field",
              },
            })
          : _c("the-mask", {
              key: "order_phone",
              ref: "phone_inp",
              staticClass: "form-control bg-transparent",
              attrs: {
                mask: ["+## (###) ###-##-##", "+## (###) ###-##-##"],
                id: "my-phone",
                type: "text",
                masked: false,
              },
              on: { change: _vm.updateValue },
              model: {
                value: _vm.drw_field,
                callback: function ($$v) {
                  _vm.drw_field = $$v
                },
                expression: "drw_field",
              },
            }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }